import { Badge } from "reactstrap";
import i18n from "../../../i18n";

export function printProductionOrderStatus(status) {
  switch (status) {
    case 'draft':
      return <Badge color="secondary">{i18n.t('common.draft')}</Badge>;
    case 'confirmed':
      return <Badge color="info">{i18n.t('production.confirmed')}</Badge>;
    case 'in_progress':
      return <Badge color="warning">{i18n.t('production.inProgress')}</Badge>;
    case 'done':
      return <Badge color="success">{i18n.t('production.done')}</Badge>;
    case 'cancelled':
      return <Badge color="danger">{i18n.t('production.cancelled')}</Badge>;
    default:
      return <Badge color="dark">{i18n.t('common.unknownStatus')}</Badge>;
  }
}

/**
 * The status an order can move to next, in the order the buttons should appear.
 * Mirrors the transition matrix the API enforces, so the UI never offers a move
 * the server will reject.
 */
export function nextStatuses(status) {
  switch (status) {
    case 'draft':
      return ['confirmed', 'cancelled'];
    case 'confirmed':
      return ['in_progress', 'cancelled'];
    case 'in_progress':
      return ['done', 'cancelled'];
    default:
      return [];
  }
}

export function isOrderEditable(order) {
  return ['draft', 'confirmed'].includes(order?.status) && !order?.components_consumed;
}
